import { DE, NL, DOMAIN_LANGUAGE } from '../constants/browser';

export const DOMAIN_TO_GTM_TAG_ID = {
  [DE]: 'GTM-TF2J3QM',
  [NL]: 'GTM-TWS3W99',
};

export const GTM_TAG_ID = DOMAIN_TO_GTM_TAG_ID[DOMAIN_LANGUAGE];
export const GTM_COOKIE_NAME =
  'CookieOptInGoogleAnalyticsCustomercenter' + DOMAIN_LANGUAGE.toUpperCase();
